module.exports = "6c8ff4e8a6abb3f98fba378d6da4e938.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/restart.png
// module id = 85
// module chunks = 0